import uniqueId from 'lodash/uniqueId'

import BrandSettingsTooltip from './DragDropTemplate/Row/tooltips/BrandSettingsTooltip/BrandSettingsTooltip'
import { INFO_TOOLTIP_SETTINGS } from './DragDropTemplate/Row/tooltips/BrandSettingsTooltip/BrandTooltipVariants'
import {
  ABOUT_BRAND,
  ABOUT_SHOWROOM,
  INFO_WIDGET,
  ONE_REGULAR,
} from './constants'

const generateAboutBrandOnlyRow = (rowType = ABOUT_BRAND) => ({
  id: uniqueId(`LOCAL_${ONE_REGULAR}_`),
  template: ONE_REGULAR,
  rowType,
  title:
    '{"ops":[{"insert":" Title"},{"attributes":{"line-height":"1","align":"center","styles":"title1"},"insert":"\\n"}]}',
  settings: {
    showTitle: false,
  },
  elements: [
    {
      id: uniqueId(`LOCAL_${INFO_WIDGET}_`),
      elementType: INFO_WIDGET,
      content: {},
    },
  ],
  tooltip: {
    component: BrandSettingsTooltip,
    settings: INFO_TOOLTIP_SETTINGS,
  },
})

export const generateAboutBrandOnlyStorefrontTemplate = () => ({
  id: uniqueId('LOCAL_STOREFRONT_'),
  rows: [generateAboutBrandOnlyRow()],
})

export const generateAboutBrandOnlyShowroomTemplate = () => ({
  id: uniqueId('LOCAL_SHOWROOM_'),
  rows: [generateAboutBrandOnlyRow(ABOUT_SHOWROOM)],
})

// New Pro brand with no storefront yet: a single online Home page with only
// the About widget, until the brand saves for the first time and gets a
// real backend-generated storefront.
const PRO_BRAND_INITIAL_STATUS_SINCE = '2025-01-08T12:00:00'

export const generateProBrandInitialTemplate = () => ({
  id: uniqueId('LOCAL_STOREFRONT_'),
  isHome: true,
  isOnline: true,
  updatedOn: PRO_BRAND_INITIAL_STATUS_SINCE,
  rows: [generateAboutBrandOnlyRow()],
})
